import React, { Component } from 'react';
import { Button, Col, Row, Modal, Input } from 'antd';
import { withRouter } from 'react-router-dom';

export class OptionForm extends Component {
  state = { profileModal: false, doctorId: '' };
  showModal = () => {
    this.setState({
      profileModal: true,
      doctorId: '',
    });
  };

  handleOk = e => {
    this.setState({
      profileModal: false,
    });
    this.props.history.push(`/doctor-profile/${this.state.doctorId}`);
  };

  handleCancel = e => {
    this.setState({
      profileModal: false,
    });
  };
  render() {
    return (
      <>
        <Row
          type="flex"
          justify="center"
          gutter={[16, 16]}
          style={{ marginTop: '8px', textAlign: 'center' }}
        >
          <Col span={8}>
            <Button
              onClick={e => this.props.history.push('/doctor-profile/new')}
            >
              New Doctor
            </Button>
          </Col>
          <Col span={8}>
            <Button onClick={e => this.showModal()}>
              Profile Already Exists
            </Button>
          </Col>
          <Col span={8}>
            <Button
              onClick={e => this.props.history.push('/center-profile/new')}
            >
              Register Health Center
            </Button>
          </Col>
          <Col span={8}>
            <Button
              onClick={e => this.props.history.push('/onboarding-request')}
            >
            Onboarding Request
            </Button>
          </Col>
        </Row>
        <Modal
          title="Enter Doctor Id"
          visible={this.state.profileModal}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <Input
            placeholder="doctor id..."
            value={this.state.doctorId}
            onChange={event => this.setState({ doctorId: event.target.value })}
          />
        </Modal>
      </>
    );
  }
}
export default withRouter(OptionForm);
